import { create } from "apisauce";

const api = create({
  baseURL: `${process.env.REACT_APP_STORAGE_URL}/v1/`,
  timeout: 100000,
});

export default api;
